import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { App } from './ui/App';
import { AppProvider } from './ui/AppContext';
import { FeedbackProvider } from './ui/Feedback';
import './ui/styles.css';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { installMonitoring } from './data/monitoring';
installMonitoring();

const colorScheme = window.matchMedia('(prefers-color-scheme: dark)');
function syncBrowserChrome() {
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', getComputedStyle(document.documentElement).getPropertyValue('--bg').trim());
}
syncBrowserChrome();
colorScheme.addEventListener('change', syncBrowserChrome);
new MutationObserver(syncBrowserChrome).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });

const updateServiceWorker = registerSW({
  immediate: true,
  onNeedRefresh() { window.dispatchEvent(new CustomEvent('nest-update-ready')); },
  onRegisterError() { window.dispatchEvent(new CustomEvent('nest-update-error')); },
});

window.addEventListener('nest-apply-update', () => {
  void updateServiceWorker(true).catch(() => window.dispatchEvent(new CustomEvent('nest-update-error')));
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><ErrorBoundary><BrowserRouter><AppProvider><FeedbackProvider><App /></FeedbackProvider></AppProvider></BrowserRouter></ErrorBoundary></React.StrictMode>
);
